import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { LOCATIONS, type Location } from "@/content/locations";
import { SERVICES, type Service } from "@/content/services";
import { CityServiceView } from "@/components/CityServiceView";
import { cityServiceHead } from "@/lib/city-service-head";
import { isProgrammableService } from "@/content/city-services";

export const Route = createFileRoute("/seo-services/$location/$service")({
  loader: ({ params }): { loc: Location; svc: Service } => {
    const loc = LOCATIONS.find((l) => l.slug === params.location);
    if (!loc) throw notFound();
    if (!isProgrammableService(params.service)) throw notFound();
    const svc = SERVICES.find((s) => s.slug === params.service);
    if (!svc) throw notFound();
    return { loc, svc };
  },
  head: ({ loaderData }) => cityServiceHead(loaderData?.loc, loaderData?.svc),
  component: CityServicePage,
  notFoundComponent: () => (
    <div className="container-x py-32 text-center">
      <h1 className="font-display text-3xl">Page not found</h1>
      <Link to="/seo-locations" className="mt-6 inline-flex text-primary">See all cities</Link>
    </div>
  ),
});

function CityServicePage() {
  const { loc, svc } = Route.useLoaderData();
  return <CityServiceView loc={loc} svc={svc} />;
}
